export default "__VITE_ASSET__JK8GYEll__"